import $ from "jquery";
import 'slick-carousel';

const simpleSlider = () => {
  const sliders = document.querySelectorAll('[data-slider=simple]');

  sliders.forEach((sliderElement) => {
    const $slider = $(sliderElement);

    $slider.on('init afterChange', (event, slick, currentSlide = slick.currentSlide) => {
      const pageIndex = currentSlide + 1;
      const pageCount = slick.slideCount;

      $slider.parents('.quotes-carousel-container')
        .find('.quotes-carousel-slider-pagination')
        .text(`${pageIndex} of ${pageCount}`);
    });

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    $slider.slick({
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      variableWidth: false,
      fade: false,
      cssEase: 'linear',
      autoplaySpeed: 0,
      speed: 500,
      infinite: true,
      arrows: true,
      dots: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1322,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 840,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });
};

export default simpleSlider;
